// 库存管理
export default [
  {
    path: '/inventory',
    meta: { title: '库存管理' },
    component: () => import('../views/inventory/index.vue'),
    children: [
      {
        path: '/inventory/definiteDetail',
        meta: { title: '库存明细', isMenu: true },
        component: () => import('../views/inventory/definiteDetail.vue'),
      },
      {
        path: '/inventory/statistics',
        meta: { title: '库存统计', isMenu: true },
        component: () => import('../views/inventory/statistics.vue'),
      },
    ],
  },
];
